module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.releasedTask')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalWorks) + " " + _vm._s(_vm.$t('word.item')))])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('button', {
    class: _vm.all || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, -1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))])]), _vm._v(" "), _c('button', {
    class: _vm.release || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, 0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.toBePaid')))])]), _vm._v(" "), _c('button', {
    class: _vm.mass || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.addition')))])]), _vm._v(" "), _c('button', {
    class: _vm.choose || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, 2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.selecting')))])]), _vm._v(" "), _c('button', {
    class: _vm.make || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, 3)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.inProduction')))])]), _vm._v(" "), _c('button', {
    class: _vm.done || 'active',
    on: {
      "click": function($event) {
        _vm.getWorks(1, 4)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.finished')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "content-right-list"
  }, [_vm._l((_vm.worksList), function(item) {
    return _c('div', {
      staticClass: "release-works-item"
    }, [_c('div', {
      staticClass: "title"
    }, [(parseInt(item.statusId) === 0) ? _c('div', [_vm._v(_vm._s(item.statusLabel))]) : _vm._e(), _vm._v(" "), (parseInt(item.statusId) !== 0) ? _c('div', [_vm._v(_vm._s(item.viewStatusLabel))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(item.demand.distributionOptionId === 3) ? _c('img', {
      staticClass: "prop-img",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'pay-album-icon@2x.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": ("" + _vm.UPLOAD_IMG_HOST + (item.coverPath)),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "content-words"
    }, [_c('p', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('word.type')) + "：" + _vm._s(item.categoryLabel))])]), _vm._v(" "), _c('div', {
      staticClass: "content-operate"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.statusId == 0),
        expression: "item.statusId==0"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.pay(item.requirementId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.toPay')))]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.statusId == 0),
        expression: "item.statusId==0"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.open(item.requirementId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('word.withDrew')))]), _vm._v(" "), _c('div', {
      staticClass: "column-layer"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.statusId > 0 && (item.viewStatusId == 2 || item.viewStatusId == 1)),
        expression: "item.statusId > 0 && (item.viewStatusId == 2 || item.viewStatusId == 1)"
      }],
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.lookupAnchor(item.requirementId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.viewStatusId == 3 || item.viewStatusId == 4),
        expression: "item.viewStatusId == 3 || item.viewStatusId == 4"
      }],
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.lookupWorks(item.requirementId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))]), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.statusId > 0 && item.isPublisher && item.cooperation.payment.prePay),
        expression: "item.statusId > 0 && item.isPublisher && item.cooperation.payment.prePay"
      }],
      staticClass: "order-detail",
      attrs: {
        "type": "text",
        "size": "small"
      },
      nativeOn: {
        "click": function($event) {
          _vm.showOrder(item.requirementId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.orderDetail')))])], 1)], 1)])])])
  }), _vm._v(" "), (_vm.totalPages >= 2) ? _c('div', {
    staticClass: "center-works-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-count": _vm.totalPages,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('comb.orderDetail'),
      "size": "tiny"
    },
    model: {
      value: (_vm.orderDialog),
      callback: function($$v) {
        _vm.orderDialog = $$v
      },
      expression: "orderDialog"
    }
  }, [_c('div', {
    staticClass: "order"
  }, [_c('div', [_c('span', [_vm._v("订单号：")]), _c('span', [_vm._v(_vm._s(_vm.order.orderNumber))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("支付金额：")]), _c('span', [_vm._v("￥" + _vm._s(_vm.order.amount))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("支付账户：")]), _c('span', [_vm._v(_vm._s(_vm.order.account))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("支付时间：")]), _c('span', [_vm._v(_vm._s(_vm.order.payTime))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("订单状态：")]), _c('span', [_vm._v(_vm._s(_vm.$t('word.paid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-buttons"
  }, [(false) ? _c('el-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('word.refund')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.orderDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.close')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66217aa0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/taskManagement/TaskManagementList.vue
// module id = 1056
// module chunks = 0